import { lazy } from 'react'
import { Navigate } from 'react-router'

import { Loadable } from 'components'

import CommonLayout from 'layout/CommonLayout'
import MainLayout from 'layout/MainLayout'
import AuthGuard from 'utils/route-guard/AuthGuard'

const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')))
const MaintenanceError500 = Loadable(
  lazy(() => import('pages/maintenance/500'))
)
const MaintenanceUnderConstruction = Loadable(
  lazy(() => import('pages/maintenance/under-construction'))
)
const MaintenanceComingSoon = Loadable(
  lazy(() => import('pages/maintenance/coming-soon'))
)
const Reports = Loadable(lazy(() => import('pages/reports-overview')))
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Customers = Loadable(lazy(() => import('pages/reports-customers')))
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const AggregateJourney = Loadable(
  lazy(() => import('pages/reports-aggregate-journey'))
)
const AiAgent = Loadable(lazy(() => import('pages/ai-agent')))
const Pages = Loadable(lazy(() => import('pages/reports-traffic-pages')))
const Organic = Loadable(lazy(() => import('pages/reports-traffic-organic')))
const Ads = Loadable(lazy(() => import('pages/reports-traffic-ads')))
const Channels = Loadable(lazy(() => import('pages/reports-traffic-channels')))
const People = Loadable(lazy(() => import('pages/activity-people')))
const ActivityDefaultRedirect = Loadable(
  lazy(
    () => import('pages/activity-people/components/activity-default-redirect')
  )
)
//const Journey = Loadable(lazy(() => import('pages/journey')))
const Conversion = Loadable(lazy(() => import('pages/conversion')))
const Tracking = Loadable(lazy(() => import('pages/setup-tracking')))
const Api = Loadable(lazy(() => import('pages/setup-api')))
const Profile = Loadable(lazy(() => import('pages/user-profile')))
const Users = Loadable(lazy(() => import('pages/user-users')))
const Settings = Loadable(lazy(() => import('pages/workspace-settings')))
const NotificationSettings = Loadable(
  lazy(() => import('pages/notification-settings'))
)
const Admin = Loadable(lazy(() => import('pages/admin')))
const Billing = Loadable(lazy(() => import('pages/workspace-billing')))
const Plan = Loadable(lazy(() => import('pages/workspace-plan')))
const Domain = Loadable(lazy(() => import('pages/setup-domain')))
const Blacklist = Loadable(lazy(() => import('pages/setup-blacklist')))
const Integrations = Loadable(lazy(() => import('pages/setup-integrations')))
const Paypal = Loadable(lazy(() => import('pages/setup-integrations/paypal')))
const Thrivecart = Loadable(
  lazy(() => import('pages/setup-integrations/thrivecart'))
)
const Clickfunnels = Loadable(
  lazy(() => import('pages/setup-integrations/clickfunnels'))
)
const Kajabi = Loadable(lazy(() => import('pages/setup-integrations/kajabi')))
const Gohighlevel = Loadable(
  lazy(() => import('pages/setup-integrations/gohighlevel'))
)
const Stripe = Loadable(lazy(() => import('pages/setup-integrations/stripe')))
const Shopify = Loadable(lazy(() => import('pages/setup-integrations/shopify')))
const Bigcommerce = Loadable(
  lazy(() => import('pages/setup-integrations/bigcommerce'))
)
const Woocommerce = Loadable(
  lazy(() => import('pages/setup-integrations/woocommerce'))
)
const Facebook = Loadable(
  lazy(() => import('pages/setup-integrations/facebook'))
)
const ConversionApi = Loadable(
  lazy(() => import('pages/setup-integrations/conversion'))
)
const Google = Loadable(lazy(() => import('pages/setup-integrations/google')))
const GoogleConversionApi = Loadable(
  lazy(() => import('pages/setup-integrations/google-conversion'))
)
const BingAds = Loadable(lazy(() => import('pages/setup-integrations/bing')))
const TiktokAds = Loadable(
  lazy(() => import('pages/setup-integrations/tiktok'))
)
// const LinkedinAds = Loadable(
//   lazy(() => import('pages/setup-integrations/linkedin'))
// )
const ChannelsTags = Loadable(lazy(() => import('pages/setup-tags/channels')))
const Forms = Loadable(lazy(() => import('pages/setup-tags/forms')))
const Products = Loadable(lazy(() => import('pages/setup-tags/products')))
const WebhooksPage = Loadable(
  lazy(() => import('pages/setup-integrations/webhooks'))
)
const WebhookEvents = Loadable(
  lazy(() => import('pages/setup-integrations/webhooks/events'))
)

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: 'reports/overview',
          element: <Reports />,
        },
        {
          path: 'reports/customers',
          element: <Customers />,
        },
        {
          path: 'reports/journey',
          element: <AggregateJourney />,
        },
        {
          path: 'ai',
          element: <AiAgent />,
        },
        {
          path: 'reports/traffic',
          children: [
            {
              path: 'channels',
              element: <Channels />,
            },
            {
              path: 'pages',
              element: <Pages />,
            },
            {
              path: 'pages/:id',
              element: <Pages />,
            },
            {
              path: 'organic',
              element: <Organic />,
            },
            {
              path: 'organic/:id',
              element: <Organic />,
            },
            {
              path: 'ads',
              element: <Ads />,
            },
            {
              path: 'ads/:id',
              element: <Ads />,
            },
          ],
        },
        {
          path: 'activity',
          children: [
            {
              index: true,
              element: <ActivityDefaultRedirect />,
            },
            {
              path: 'visitor',
              element: <People />,
            },
            {
              path: 'lead',
              element: <People />,
            },
            {
              path: 'customer',
              element: <People />,
            },
          ],
        },
        {
          path: 'conversions',
          children: [
            {
              path: 'forms',
              element: <Conversion />,
            },
            {
              path: 'leads',
              element: <Conversion />,
            },
            {
              path: 'orders',
              element: <Conversion />,
            },
            {
              path: 'refunds',
              element: <Conversion />,
            },
            {
              path: 'recurring',
              element: <Conversion />,
            },
          ],
        },
        // {
        //   path: 'journey',
        //   element: <Journey />,
        //   children: [
        //     {
        //       path: 'create',
        //       element: <Journey />,
        //     },
        //     {
        //       path: 'edit/:id',
        //       element: <Journey />,
        //     },
        //   ],
        // },
        // {
        //   path: 'journey/:id',
        //   element: <Journey />,
        // },
        {
          path: 'setup',
          children: [
            {
              path: 'tracking',
              element: <Tracking />,
            },
            {
              path: 'apps',
              element: <Integrations />,
            },
            {
              path: 'domain',
              element: <Domain />,
            },
            {
              path: 'blacklist',
              element: <Blacklist />,
            },
            {
              path: 'channels',
              element: <ChannelsTags />,
            },
          ],
        },
        {
          path: 'thrivecart',
          element: <Thrivecart />,
        },
        {
          path: 'clickfunnels',
          element: <Clickfunnels />,
        },
        {
          path: 'kajabi',
          element: <Kajabi />,
        },
        {
          path: 'gohighlevel',
          element: <Gohighlevel />,
        },
        {
          path: 'leadconnector',
          element: <Gohighlevel />,
        },
        {
          path: 'paypal',
          element: <Paypal />,
        },
        {
          path: 'woocommerce',
          element: <Woocommerce />,
        },
        {
          path: 'shopify',
          element: <Shopify />,
        },
        {
          path: 'bigcommerce',
          element: <Bigcommerce />,
        },
        {
          path: 'stripe',
          element: <Stripe />,
        },
        {
          path: 'facebook_ads',
          element: <Facebook />,
        },
        {
          path: 'facebook_ads/:id',
          element: <ConversionApi />,
        },
        {
          path: 'google_ads',
          element: <Google />,
        },
        {
          path: 'google_ads/:id',
          element: <GoogleConversionApi />,
        },
        {
          path: 'bing',
          element: <BingAds />,
        },
        {
          path: 'tiktok_ads',
          element: <TiktokAds />,
        },
        // {
        //   path: 'linkedin',
        //   element: <LinkedinAds />,
        // },
        {
          path: 'webhooks',
          element: <WebhooksPage />,
        },
        {
          path: 'webhooks/:id',
          element: <WebhookEvents />,
        },
        {
          path: 'tags',
          children: [
            {
              path: 'channels',
              element: (
                <Navigate
                  to="/setup/channels"
                  replace
                />
              ),
            },
            {
              path: 'websites',
              element: (
                <Navigate
                  to="/setup/tracking"
                  replace
                />
              ),
            },
            {
              path: 'forms',
              element: <Forms />,
            },
            {
              path: 'products',
              element: <Products />,
            },
          ],
        },
        {
          path: 'admin',
          element: <Admin />,
        },
        {
          path: 'developer',
          children: [
            {
              path: 'api',
              element: <Api />,
            },
          ],
        },
        {
          path: 'settings',
          children: [
            {
              path: 'general',
              element: <Settings />,
            },
            {
              path: 'billing',
              element: <Billing />,
            },
            {
              path: 'plan',
              element: <Plan />,
            },
            {
              path: 'plan',
              element: <Plan />,
            },
            {
              path: 'users',
              element: <Users />,
            },
            {
              path: 'notifications',
              element: <NotificationSettings />,
            },
          ],
        },
        {
          path: 'profile',
          element: <Profile />,
        },
      ],
    },
    {
      path: '/maintenance',
      element: <CommonLayout />,
      children: [
        {
          path: '404',
          element: <MaintenanceError />,
        },
        {
          path: '500',
          element: <MaintenanceError500 />,
        },
        {
          path: 'under-construction',
          element: <MaintenanceUnderConstruction />,
        },
        {
          path: 'coming-soon',
          element: <MaintenanceComingSoon />,
        },
      ],
    },
    {
      path: '*',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
    },
  ],
}

export default MainRoutes
